// extracted by mini-css-extract-plugin
export default {"container":"ProfileCard_container__OKqYk","name":"ProfileCard_name__+izU4","leftContainer":"ProfileCard_leftContainer__433dO"};